module.exports = __webpack_public_path__ + "img/online-support-chat.1a244eb9.png";